module.exports = __webpack_public_path__ + "static/media/Twitter.4f42836f.svg";